import useActiveSocialProfile from '@/utils/hooks/user/useActiveSocialProfile';

import type { SocialProfileNetworkType } from '@/types/socialProfileType';

export type NetworkTypeVisibilityGateProps = {
    /** Networks for which the banner is displayed (e.g. [X, INSTAGRAM]) */
    networks: SocialProfileNetworkType[];
    /** Content shown when the active network matches (text, FAQ link, etc.) */
    children: React.ReactNode;
    /** Optional className for the wrapper (placement, margins) */
    className?: string;
};

export const NetworkTypeVisibilityGate = ({
    networks,
    children,
    className = ''
}: NetworkTypeVisibilityGateProps) => {
    const { activeSocialProfile } = useActiveSocialProfile();
    const isVisible =
        activeSocialProfile?.social_network_type != null &&
        networks.includes(activeSocialProfile.social_network_type);

    if (!isVisible) {
        return null;
    }

    return (
        <div
            className={className}
            role="status"
            aria-live="polite"
            data-testid="network-information-banner">
            {children}
        </div>
    );
};
